export const routePaths = {
  0: "about-your-organization",
  1: "contacts",
  2: "program-specific",
  3: "travel-and-logistics",
  4: "affiliations",
  5: "deposit",
};
